var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Caption from "./Caption";
import { css, mq, styled } from "../utils";
import Text, { TextProps } from "./Text";
var StyledDataRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 1rem 0;\n\n  & > div {\n    display: flex;\n    justify-content: space-between;\n\n    ", "\n  }\n"], ["\n  margin: 1rem 0;\n\n  & > div {\n    display: flex;\n    justify-content: space-between;\n\n    ",
    "\n  }\n"])), mq({
    flexDirection: ['column', 'row'],
}));
var Label = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  margin: 0;\n"], ["\n  flex: 1;\n  margin: 0;\n"])));
var Value = styled(Label)(function (_a) {
    var font = _a.theme.font;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: ", ";\n\n    ", "\n  "], ["\n    font-weight: ", ";\n\n    ",
        "\n  "])), font.weight.semiBold, mq({
        textAlign: ['left', 'right'],
        marginLeft: [0, '1rem', '2rem', '3rem'],
    }));
});
var Placeholder = styled(Value)(function (_a) {
    var _b = _a.theme, font = _b.font, colors = _b.colors;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: ", ";\n    font-style: italic;\n  "], ["\n    color: ", ";\n    font-weight: ", ";\n    font-style: italic;\n  "])), colors.placeholder, font.weight.normal);
});
var DataRow = function (_a) {
    var label = _a.label, value = _a.value, caption = _a.caption, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, className = _a.className, textProps = __rest(_a, ["label", "value", "caption", "placeholder", "className"]);
    return (React.createElement(StyledDataRow, { className: className },
        React.createElement("div", null,
            React.createElement(Label, __assign({}, textProps), label),
            value ? React.createElement(Value, __assign({}, textProps), value) : React.createElement(Placeholder, null, placeholder)),
        caption && (React.createElement(Caption, { mb: 0, mt: "4px", light: true }, caption))));
};
export default DataRow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=DataRow.js.map